// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StickerPack__container-f5c73d {
  padding: 0 3px;
  box-sizing: content-box;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
  flex: 0 0 auto;
  font-size: 0;
}

.StickerPack__container-f5c73d:hover {
  background-color: var(--base-20);
}

@supports (display: block) {
  .StickerPack__container-f5c73d:focus-visible {
    background-color: var(--base-20);
  }
}
.StickerPack__container-f5c73d:active {
  background-color: var(--base-30);
}

.StickerPack__active-c9739e {
  background-color: var(--base-30);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/EmojisStickersButton/EmojiStickersPanel/StickerPanel/StickerPackList/StickerPack/StickerPack.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE;IACE,gCAAA;EACF;AACF;AAEA;EACE,gCAAA;AAAF;;AAGA;EACE,gCAAA;AAAF","sourcesContent":[".container {\n  padding: 0 3px;\n  box-sizing: content-box;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  flex: 0 0 auto;\n  font-size: 0;\n}\n\n.container:hover {\n  background-color: var(--base-20);\n}\n\n@supports (display: block) {\n  .container:focus-visible {\n    background-color: var(--base-20);\n  }\n}\n\n.container:active {\n  background-color: var(--base-30);\n}\n\n.active {\n  background-color: var(--base-30);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StickerPack__container-f5c73d`,
	"active": `StickerPack__active-c9739e`
};
module.exports = ___CSS_LOADER_EXPORT___;
